export function isEmpty(value) {
  return value > 0
}
